export default __webpack_public_path__ + "static/media/1.f66c10c4.jpg";